// export const validateEmail = (email) => {
//   const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//   return emailRegex.test(email) && email.length > 0;
// };


export const validateEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

export const validateName = (name) => {
  return name.trim().length > 0 && /^[a-zA-Z\s]+$/.test(name);
};

export const validatePassword = (password) => {
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password); 
  const isValidLength = password.length >= 8 && password.length <= 64;

  return hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar && isValidLength;
};

export const validatePhone = (number, setPhoneNumber, setValid) => {
  
  
  
  
  
  
  const isValid = number.length > 0 && /^\d{10}$/.test(number);
  return isValid;
};






export const validatePinCode = (pin, setPinCode, setValidPin) => {
  
  
  
  const isValidPin = /^\d{5,6}$/.test(pin); 
  
  return isValidPin;
};
